<template>
  <div class="content pt-3 pb-0 pl-0 pr-0" style="background-color: #F76E2A !important">
    <div class="container-fluid">
      <div class="row">
        <!-- Contador de usuarios registrados -->

        <!-- Boostrap Card -->
        <div class="col-lg-12 col-md-12">
          <div class="card card-stats">
            <div class="card-header card-header-warning"></div>
            <div class="card-body">
              <div class="row">
                <img
                  src="@/assets/img/logo.png"
                  class="mx-auto"
                  alt=""
                  style="width: 100px"
                />
              </div>
              <div class="row">
                <p class="mx-auto">Hola <strong>{{ user.full_name }}</strong> </p>
                </div>
              <div class="row">
                
                <span class="mx-auto" style="font-size: 20px;">Rutas en proceso</span>
              </div>
              <div class="row">
                <div class="col-md-12">
                  {{ humanDate(new Date()) }}
                </div>
              </div>

              <div class="row col-12 p-0" >
                <div class="col-md-4" v-for="route in routes" :key="route.id">
                  <RouteCard :route="route" />
                </div>
               
              </div>  
            </div>
           
          </div>
        </div>

        <!-- Contador de usuarios aprobados -->

        <!-- Contador de usuarios pendientes -->

        <!-- Contador de usuarios rechazados -->
      </div>

      <!-- Gráfica de torta con los estados de suscripción -->
      <div class="row"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import RouteCard from './Component/RouteCard.vue'
import jsCookie from 'js-cookie';
export default {
  name: 'RouteHome',
  components: {
    RouteCard
  },
  data() {
    return {
      HelloWorld: 'Inicio de Rutas',
      routes: [],
      isBusy: false,
      user:{ },
      metaInfo: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  methods: {
    ...mapActions(['getData', 'changeStatusData']),
    viewDetail(route) {
      console.log(route)
      this.$router.push({ name: 'ServiceDetail', params: { id: route.id } })
    },
    loadChildren(id_user) {
      let form = {
        url: 'user_children/all',
        params: {
          id_user_parent: this.user.id,
          active: 1,
          order_by: 'id',
          order_key: 'desc'
        }
      }
        this.getData(form)
          .then((response) => {
            this.childrens = response.data

            //foreach children
            this.childrens.forEach((children) => {
              if(children.id > 0){
                this.loadElements(children.id)
              }
            });
             
          })
          .catch((error) => {
            console.log(error)
          })
          
    
  },
    loadElements(id_children) {
      let form = {
        url: 'service/all',
        params: {
          id_user_children: id_children,
          active:1,
          id_status_service:'[1,2,3,4,5]',
          order_key: 'id',
          order_value: 'desc',
          
        }
      }

      

      if (this.finder != '') {
        form.params.query = this.finder
      }
      this.isBusy = true
      this.getData(form)
        .then((response) => {
          this.isBusy = false
          if (response.code === 200) {

            //If routes already have elements, push new elements
            if (this.routes.length > 0) {
              this.routes = this.routes.concat(response.data)
            }else{
              this.routes = response.data
            }
            console.log(this.routes)
         
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    humanDate(date) {
      //Format in legible date
      moment.locale('es')
      return moment(date).format('dddd DD [de] MMMM [de] YYYY')
    }
  },
  mounted() {
    //get user from cookie
    let user = jsCookie.get('user')
    //format json data
    this.user = JSON.parse(user)

    if(this.user){
      this.loadChildren(this.user.id)
    }
    
    
    
    
    
  }
}
</script>

<style scoped>
.card-title {
  transition: all 0.2s ease-in-out;
}
</style>
